import { inferRouterOutputs } from "@trpc/server";

import { AppRouterType, trpc } from "../../../common/helpers/trpc";

export type EmailContentBuilderType =
  inferRouterOutputs<AppRouterType>["getEmailContentWithFormData"]["emailContent"] & {
    attachment: {
      fileUrl: string;
    };
    wasConverted?: boolean;
  };

export const useGetEmailContent = (emailContentId?: string) => {
  const {
    data: getEmailContentWithFormData,
    refetch,
    isLoading,
    error,
  } = trpc.getEmailContentWithFormData.useQuery(
    { emailContentId: emailContentId as string },
    { enabled: Boolean(emailContentId), gcTime: 0 }
  );

  if (!getEmailContentWithFormData?.emailContent) {
    return { emailContent: undefined, refetchEmailContent: refetch, error };
  }

  const emailContent: EmailContentBuilderType = {
    ...getEmailContentWithFormData.emailContent,
    recipientEmails: getEmailContentWithFormData.manualRecipientEmails,
    attachment: {
      fileUrl: getEmailContentWithFormData.emailContent?.attachmentUrl || "",
    },
    wasConverted: getEmailContentWithFormData.wasConverted,
  };

  const linkedForm = getEmailContentWithFormData.linkedForm;

  const refetchEmailContent = async () => {
    if (emailContentId) {
      await refetch();
    }
  };

  return { emailContent, refetchEmailContent, isLoading, linkedForm, error };
};
